// pdfExport.js — paverčia Suvestinės DOM puslapius (elementus su klase
// "fitit-summary-page") į vieną daugiapuslapį PDF. Kiekvienas puslapis
// nufotografuojamas html2canvas ir įdedamas kaip pilno lapo vaizdas —
// tai patikimai veikia ir su statiniu tekstu, ir su iš anksto sugeneruotais
// brėžinių PNG paveikslėliais (kurie tuo metu jau yra paprasti <img>, o ne
// gyvas WebGL canvas'as, tad html2canvas juos fotografuoja be problemų).

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const exportSummaryToPdf = async (rootElement, filename = 'suvestine.pdf') => {
    if (!rootElement) return false;
    const pages = rootElement.querySelectorAll('.fitit-summary-page');
    if (!pages.length) return false;

    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const pageWidthMm = pdf.internal.pageSize.getWidth();
    const pageHeightMm = pdf.internal.pageSize.getHeight();

    for (let i = 0; i < pages.length; i++) {
        const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
        const imgData = canvas.toDataURL('image/jpeg', 0.92);

        let imgWidthMm = pageWidthMm;
        let imgHeightMm = (canvas.height * imgWidthMm) / canvas.width;
        let xOffset = 0;
        if (imgHeightMm > pageHeightMm) {
            imgHeightMm = pageHeightMm;
            imgWidthMm = (canvas.width * imgHeightMm) / canvas.height;
            xOffset = (pageWidthMm - imgWidthMm) / 2;
        }

        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'JPEG', Math.max(0, xOffset), 0, imgWidthMm, imgHeightMm);
    }

    pdf.save(filename);
    return true;
};
